import classNames from "../../../consts/classNames";

const Description = () => {
  return (
    <div className={`${classNames.containerClass} mt-10 lg:mt-20`}>
      <h1 className="text-3xl lg:text-5xl max-w-[75%] font-bold mx-auto text-center">
        Teamfight-tactics
      </h1>
      <div className="space-y-12 mt-6 text-gray-400">
        <div>
          <strong className="text-lg text-white">
            What is TFT Rank Boost?
          </strong>
          <p>
            TFT Rank Boost is a service designed to help players improve their
            rank in Teamfight Tactics (TFT), the auto-battler game from Riot
            Games. This service involves skilled players or professional
            boosters who play on your account to achieve higher ranks or
            divisions. By leveraging their expertise, you can quickly progress
            through the ranks, overcome skill barriers, and experience higher
            levels of competitive play. It’s ideal for players looking to
            advance their rank efficiently or to overcome difficult patches and
            matchups.
          </p>
        </div>
        <div className="space-y-4">
          <strong className="text-lg text-white">
            What is TFT Division Boost?
          </strong>
          <p>
            TFT Division Boost is a specific type of rank boosting service
            focused on advancing a player&apos;s division within Teamfight
            Tactics (TFT). It involves expert players who play on your account
            to help you move up from your current division to a higher one. This
            service aims to improve your overall rank and achieve specific
            division goals, providing you with a faster path to reaching higher
            levels of competitive play. It&apos;s ideal for players looking to
            break through a particular division or enhance their standings with
            the help of experienced boosters.
          </p>
        </div>
        <div className="space-y-4">
          <strong className="text-lg text-white">
            Top-Rated TFT Ranked Boost
          </strong>
          <p>
            Top-rated TFT Ranked Boost provides exceptional support for players
            aiming to climb the competitive ladder in Teamfight Tactics. With
            highly skilled boosters and a proven track record, this service
            ensures efficient and reliable progress through the ranks. Benefit
            from expert strategies, optimized gameplay, and personalized
            attention to reach your desired rank quickly and effectively. Choose
            our top-rated service for a premium experience and significant
            improvement in your TFT rankings.
          </p>
        </div>
        <div className="space-y-4">
          <strong className="text-lg text-white">
            Play with Top Tier Challenger Players
          </strong>
          <div className="space-y-4">
            Play with Challenger players and elevate your Teamfight Tactics
            experience. Engage with top-tier competitors to gain valuable
            insights, improve your strategies, and challenge yourself at the
            highest level of play. This opportunity allows you to learn from the
            best, enhance your skills, and enjoy a more competitive and
            rewarding gaming experience.
          </div>
        </div>
        <div className="space-y-4">
          <strong className="text-lg text-white">
            Achieve Your Dream Rank
          </strong>
          <div className="space-y-4">
            Achieve your dream rank quickly with our expert boosting services.
            Our skilled professionals will accelerate your progress, helping you
            reach your desired rank efficiently. Whether you’re aiming for a
            personal best or striving to break through a tough division, we
            provide the support you need to climb the ranks and achieve your
            goals faster.
          </div>
        </div>
        <div className="space-y-4">
          <strong className="text-lg text-white">Save Time and Effort</strong>
          <div className="space-y-4">
            Our rank boost service lets you swiftly achieve your desired rank
            without the extensive time and effort usually required to climb the
            ranks on your own. Enjoy a faster progression with expert
            assistance, allowing you to reach your goals efficiently and
            effectively.
          </div>
        </div>
        <div className="space-y-4">
          <strong className="text-lg text-white">Reach Higher Levels</strong>
          <div className="space-y-4">
            Reach higher levels with ease through our professional rank boost
            service. Whether you&apos;re aiming for new personal bests or
            striving to break into top-tier ranks, our expert team will help you
            elevate your gameplay and achieve your goals faster. Experience
            enhanced performance and progress with minimal effort on your part.
          </div>
        </div>
        <div className="space-y-4">
          <strong className="text-lg text-white">
            Learn from the Best Players
          </strong>
          <div className="space-y-4">
            Learn from the best with our top-tier coaching and boosting
            services. Gain valuable insights and strategies from highly skilled
            players who can help you refine your skills and elevate your
            gameplay. By studying their techniques and receiving personalized
            feedback, you&apos;ll accelerate your improvement and reach new
            heights in your game..
          </div>
        </div>
        <div className="space-y-4">
          <strong className="text-lg text-white">Enhanced Matchmaking</strong>
          <div className="space-y-4">
            Enhanced matchmaking with our expert TFT Boost ensures you face
            opponents of a higher caliber and experience more balanced,
            challenging games. By improving your rank and refining your skills,
            you’ll enjoy a more competitive and rewarding gameplay experience,
            making each match more engaging and fulfilling.
          </div>
        </div>
      </div>
    </div>
  );
};
export default Description;
